import {
	Component,
	ElementRef,
	Input,
	OnInit,
	HostListener,
} from '@angular/core'
import { HelpersService } from 'src/app/services/helpers/helpers.service'

@Component({
	selector: 'app-white-card',
	templateUrl: './white-card.component.html',
	styleUrls: ['./white-card.component.scss'],
})
export class WhiteCardComponent implements OnInit {
	@Input() type = ''
	@Input() showButton: boolean = true
	@Input() cards: any
	@Input() title: string
	@Input() body: string
	@Input() subtitle: string
	constructor(private helpers: HelpersService) {}

	ngOnInit(): void {}
	
	removeLangFromRoute(url: any) {
		return this.helpers.removeLangFromRoute(url)
	}
}
